import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PermissionRoute = ({ children, permission, permissions = [] }) => {
  const userPermissions = useSelector((state) => state.auth.permissions || []);

  let allowed = false;

  if (permission) {
    allowed = userPermissions.includes(permission);
  } else if (permissions.length) {
    allowed = permissions.some((item) => userPermissions.includes(item));
  }

  return allowed ? children : <Navigate to="/unauthorized" replace />;
};

export default PermissionRoute;
